<template lang="pug">
#measureTool
  .appTools.map
    .level(@click="selectMeasure")
      .type(:title="measureData.name")
        span 模式：
        img(:src='measureData.icon' :title='measureData.name' alt='图标')
        span {{measureData.name}}
      i.el-icon-arrow-up
    .level(@click="selectUnitList")
      .type(:title="unitData.label") 单位：{{unitData.label}}
      i.el-icon-arrow-up
    .level
      el-checkbox(v-model="continuous",size="mini" @change="measureChange") 连续
    i.el-icon-minus.close(title="最小化",@click="closeAdd")
  //- 测量模式
  transition(name="el-fade-in-linea")
    .measureType(v-if="typeShow")
      .chil(v-for="item in measureFuncList" :key="item.query" :class="{'isActive': item.query == measureData.query}" @click="changeType(item)")
        img(:src="item.icon" :title='item.name' alt='图标')
        span {{item.name}}
  //- 测量单位
  transition(name="el-fade-in-linea")
    .measureUnit(v-if="unitShow")
      .chil(v-for="item in unitList" :key="item.value" :class="{'isActive': item.value == unitData.value}" @click="changeUnit(item)")
        span {{item.label}}
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  data () {
    return {
      measureFuncList: [
        { name: "距离测量", icon: require("./../images/距离测量.png"), query: Monge.MeasureType2D.DISTANCE, isActive: false },
        { name: "面积测量", icon: require("./../images/面积测量.png"), query: Monge.MeasureType2D.AREA, isActive: false },
        { name: "角度测量", icon: require("./../images/角度测量.png"), query: Monge.MeasureType2D.ANGLE, isActive: false },
        { name: "清除测量", icon: require("./../images/清除测量.png"), query: "close", isActive: false }
      ],
      unitList: [
        { value: Monge.Unit.MM, label: "毫米" },
        { value: Monge.Unit.CM, label: "厘米" },
        { value: Monge.Unit.M, label: "米" },
        { value: Monge.Unit.FT, label: "英尺" }
      ],
      measureData: {},
      unitData: {},
      typeShow: false,
      unitShow: false,
      continuous: false// 连续
    };
  },
  mounted () {
    this.measureData = this.measureFuncList[0];
    this.unitData = this.unitList[0];
    this.startMeasure2D();
  },
  methods: {
    // 选择测量类型
    selectMeasure() {
      this.typeShow = !this.typeShow;
    },
    selectUnitList() {
      this.unitShow = !this.unitShow;
    },
    changeType(item) {
      if (item.query == "close") {
        mongeApiMlib.clearMapMeasure();
        this.typeShow = false;
        return;
      }
      this.measureData = item;
      this.typeShow = false;
      this.startMeasure2D();
    },
    changeUnit(item) {
      this.unitData = item;
      this.unitShow = false;
      this.startMeasure2D();
    },
    measureChange(val) {
      if (val) {
        this.startMeasure2D();
      } else {
        mongeApiMlib.deactiveMapMeasure();
      }
    },
    async startMeasure2D() {
      await mongeApiMlib.measure2D(this.measureData.query, this.unitData.value, this.continuous);
    },
    closeAdd() {
      mongeApiMlib.deactiveMapMeasure();
      this.$emit("closeCom", 'measure', true);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
.appTools{
  width: 400px;
  left: calc(50% - 200px);
}
.measureType,.measureUnit{
  position: absolute;
  width: 125px;
  height: 100px;
  overflow-x: hidden;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  border-radius: 4px;
  left: calc(50% - 170px);
  bottom: 35px;
  padding: 5px 0;
  z-index: 4;
  .chil{
    padding: 0 14px;
    margin-top: 2px;
    width: 100%;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    img{
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
  .chil:hover{
    background: rgba(56, 115, 254, 0.38);
  }
  .isActive{
    background: rgba(56, 115, 254, 0.38);
  }
}
.measureUnit{
  left: calc(50% + 25px);
  width: 60px;
}
// .measureFunc{
//   position: absolute;
//   bottom: 95px;
//   left: calc(50% - 180px);
//   width: 114px;
//   height: 178px;
//   background: rgba(0, 0, 0, 0.68);
//   box-shadow: 0px 0px 8px 2px rgba(97, 110, 139, 0.78);
//   border-radius: 4px;
//   display: flex;
//   flex-direction: column;
//   padding: 10px 0;
//   z-index: 4;
//   .mList{
//     width: 100%;
//     height: 38px;
//     display: flex;
//     flex-direction: row;
//     align-items: center;
//     color: #fff;
//     cursor: pointer;
//     span{
//       font-size: 14px;
//       line-height: 38px;
//     }
//     .iconRed{
//       width: 4px;
//       height: 4px;
//       border-radius: 4px;
//       margin-left: 5px;
//     }
//     .active{
//       background: #FF0000;
//     }
//     img{
//       margin:  0 5px;
//     }
//   }
//   .isActiveMList{
//     background-color: #fff;
//     background: rgba(56, 115, 254, 0.18);
//   }
//   .mList:hover{
//     background-color: #fff;
//     background: rgba(56, 115, 254, 0.18);
//   }
// }
</style>
